module.exports = __webpack_public_path__ + "img/display_publish_eye_visibility.1d6ce637.svg";